import StubPage from '../../components/StubPage.jsx';

export default function CommunityPage() {
  return (
    <StubPage
      title="Portfolio & community"
      description="Public profiles, discovery, likes, and a marketplace of templates."
      planned={[
        'Public creator profiles showcasing published sites',
        'Like, comment, and follow primitives across the network',
        'Discovery feed sorted by recency, trending, and category',
        'Template marketplace with paid + free templates',
      ]}
    />
  );
}
